import { DirectiveBinding } from "vue"

export default {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    toggleCollapse(el, binding.value)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    toggleCollapse(el, binding.value)
  },
}

function toggleCollapse(el: HTMLElement, value: DirectiveBinding) {
  if (value) {
    el.classList.remove('collapse')
  } else {
    el.classList.add('collapse')
  }
}
